<template>
  <teleport to="body">
    <transition name="slide-up" appear>
      <div
        v-if="message"
        class="fixed z-[9999] pointer-events-none
               left-1/2 -translate-x-1/2
               sm:left-auto sm:translate-x-0 sm:right-6"
        :style="{ bottom: `calc(${bottomPx} + env(safe-area-inset-bottom, 0px))`, '--primary-color': primaryColor }"
      >
        <div
          class="pointer-events-auto flex items-center gap-2
                 px-4 py-2 rounded-full shadow-lg
                 text-white font-medium
                 bg-[var(--primary-color,#009669)]
                 min-h-[44px]
                 w-[calc(100vw-32px)] max-w-[680px]
                 sm:w-auto sm:max-w-[720px]"  
        >
          <span class="inline-flex items-center justify-center h-6 w-6 rounded-full bg-white flex-shrink-0">
            <svg viewBox="0 0 20 20" class="h-4 w-4" :style="{ color: iconColor }" fill="currentColor">
              <path fill-rule="evenodd"
                d="M16.704 5.29a1 1 0 010 1.415l-7.2 7.2a1 1 0 01-1.415 0l-3-3a1 1 0 111.414-1.415l2.293 2.293 6.493-6.493a1 1 0 011.415 0z"
                clip-rule="evenodd" />
            </svg>
          </span>

          
          <span class="hidden sm:inline text-[14px] leading-5 whitespace-nowrap overflow-hidden text-ellipsis">
            {{ message }}
          </span>

<span
  class="sm:hidden block text-[14px] leading-5 whitespace-normal break-words min-w-0 flex-1 text-left"
  v-html="mobileMessageHtml"
/>



        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup lang="ts">
import { getPrimaryColor } from '~/composables/theme';
const primaryColor = getPrimaryColor();
const props = withDefaults(defineProps<{
  message: string | null
  footerHeight?: number
  iconHex?: string
  durationMs?: number
}>(), {
  footerHeight: 56,
  iconHex: '#009669',
  durationMs: 3000
})

const iconColor = computed(() => props.iconHex)
const bottomPx = computed(() => `${props.footerHeight + 8}px`)

const mobileMessageHtml = computed(() => {
  const msg = props.message ?? ''


  if (msg.length > 40 && msg.includes('!')) {

    return msg.replace(/!+(\s*)/, (m, s) => `${m}<br>`)
  }


  return msg
})


onMounted(() => {
  setTimeout(() => { useState<string | null>('loginBannerMessage').value = null }, props.durationMs)
})
</script>

<style scoped>
.slide-up-enter-active, .slide-up-leave-active { transition: transform .28s ease, opacity .28s ease; }
.slide-up-enter-from, .slide-up-leave-to { transform: translateY(100%); opacity: 0; }
</style>